import { FC, MouseEvent } from 'react';
import { TabProps } from './Tab.types';
import { TabStyled } from './Tab.styles';
import { useNavigate } from 'react-router-dom';

const Tab: FC<TabProps> = (props) => {
  const { css, disabled, id, label, onClick, panelId, selected, size, url, value } = props;
  const navigate = useNavigate();
  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    if (selected !== true && disabled !== true && onClick != null) {
      onClick(event, value);
    }

    if (url) {
      navigate(url);
    }
  };

  return (
    <TabStyled
      aria-selected={selected}
      aria-controls={panelId}
      css={{ ...css }}
      disabled={disabled}
      id={id}
      onClick={handleClick}
      role="tab"
      selected={selected}
      tabIndex={disabled === true ? -1 : 0}
      type="button"
      value={value}
      size={size}
    >
      {label}
    </TabStyled>
  );
};

export default Tab;
